// extracted by mini-css-extract-plugin
export default {"button":"glass-button_button__n9Z9y","label":"glass-button_label__CD1e8","spinner":"glass-button_spinner__zX8Ao","spin":"glass-button_spin__f-Nco"};